<template>
    <a-space>
        <a-button type="primary" @click="saveFunnel" :disabled="!funnelStore.allowSave">
            <SaveOutlined /> Save
        </a-button>
        <a-button v-if="route.path.includes('funnel-view-edit')" type="primary" @click="publishFunnel" :disabled="!funnelStore.allowPublish">Publish</a-button>
    </a-space>
</template>

<script setup lang="ts">
import { useFunnelStore } from '@/store/modules/funnel'
import { useRoute } from 'vue-router'
import { SaveOutlined } from '@ant-design/icons-vue'

const funnelStore = useFunnelStore()
const route = useRoute()

const saveFunnel = async () => {
    if (funnelStore.activeSave) {
        await funnelStore.updateSaveState(false)
        await funnelStore.updateSaveState(true)
    } else {
        await funnelStore.updateSaveState(true)
    }
}

const publishFunnel = async () => {
    funnelStore.updatePublishState(true)
}
</script>